export default __webpack_public_path__ + "static/media/EurostileBold.f4670378.ttf";